import { AbstractControl, ValidatorFn } from '@angular/forms';

export function compare(fields: string[]): ValidatorFn {
  return (formGroup: AbstractControl) => {
    const { result: equals } = fields
      .map(field => formGroup.get(field))
      .reduce<{ previous: AbstractControl, result: boolean }>(
        ({ previous, result }, current) => ({ previous: current, result: result && (!previous || current.value === previous.value) }),
        { previous: null, result: true }
      );
    return !equals
      ? { compare: true }
      : null;
  };
}
